import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import ContactModal from './components/ContactModal';

function Navigation({ onContactClick }) {
  const location = useLocation();
  
  const handleLogoClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/" className="logo-link" onClick={handleLogoClick}>
            <span className="logo-code">&lt;RSS&gt;</span>
            <span className="logo-text"> Insight</span>
          </Link>
        </div>
        <div className="nav-links">
          <button 
            className="nav-link contact-btn"
            onClick={onContactClick}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}

function AppContent() {
  const [showContactModal, setShowContactModal] = useState(false);

  const handleContactClick = () => {
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };

  const handleFooterLogoClick = (e) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="app">
      <div className="app-background" />
      
      <div className="scrollable-content">
        <Navigation onContactClick={handleContactClick} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home onContactClick={handleContactClick} />} />
          </Routes>
        </main>
      </div>

      <footer className="site-footer">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-section">
              <h4>Navigation</h4>
              <nav className="footer-nav">
                <Link to="/">Home</Link>
                <button type="button" onClick={handleContactClick} className="footer-link-button">Contact</button>
              </nav>
            </div>
            
            <div className="footer-section">
              <h4>Connect</h4>
              <div className="social-links">
                <a href="mailto:mike@rssinsight.com" target="_blank" rel="noopener noreferrer" aria-label="Email">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                  Email
                </a>
              </div>
            </div>
            
            <div className="footer-section">
              <div className="definition">
                <div className="definition-meaning">
                  RSS Insight is an enterprise podcast analytics platform geared towards large broadcasters and media entities, whose digital audio presence spans across RSS Feeds, YouTube, Spotify, and iTunes.
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} RSS Insight. All rights reserved.</p>
            </div>
            <div className="footer-logo">
              <Link to="/" aria-label="Return to home" onClick={handleFooterLogoClick}>
                <span className="footer-logo-code">&lt;RSS&gt;</span>
                <span className="footer-logo-text"> Insight</span>
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {showContactModal && (
        <ContactModal onClose={handleCloseContactModal} />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

